const {
  USE_LOGGING,
  ENDPOINT_BFF,
  ENDPOINT_WS,
  WS_HEARTBEAT_INTERVAL_SECONDS,
  MEDIA_BUCKET_BASE_URL,
  ENDPOINT_IAM,
  GOOGLE_MAPS_API_KEY,
  GOOGLE_MAPS_MAP_ID,
  YOUTUBE_API_KEY,
  GOOGLE_RECAPTCHA_SITE_KEY,
  ENDPOINT_ISIM_LOGIN,
  ISIM_LOGIN_CLIENT_ID,
  IAM_CLIENT,
  SENTRYIO_DSN,
  ASSETS_BATCH_SIZE,
  FB_API_KEY,
  FB_PROJECT_ID,
  FB_MESSAGING_SENDER_ID,
  FB_APP_ID,
  FB_MEASUREMENT_ID,
  FB_AUTH_DOMAIN,
  FB_DATABASE_URL,
  FB_STORAGE_BUCKET,
  FB_APP_NAME,
  FB_CONFIG_FETCH_INTERVAL,
  DIAM_ACCOUNT_PORTAL_URL,
  HFS_WEB_VERSION,
  OIDC_URL,
  OIDC_CLIENT_ID,
  OIDC_REDIRECT_URL,
  OIDC_LOGOUT_REDIRECT_URL,
  MS_CLARITY_CODE,
  APP_ENV,
  APP_SCHEME,
  APP_NAME,
  MAX_IMAGE_UPLOAD_MB = 20,
} = process.env;

export const appServices = {
  bff: ENDPOINT_BFF,
  ws: ENDPOINT_WS,
  mediaBucketBaseUrl: MEDIA_BUCKET_BASE_URL,
  sentryDsn: SENTRYIO_DSN,
  msClarityCode: MS_CLARITY_CODE,
};

export const googleServices = {
  mapsApiKey: GOOGLE_MAPS_API_KEY,
  youtubeApiKey: YOUTUBE_API_KEY,
  recaptchaSiteKey: GOOGLE_RECAPTCHA_SITE_KEY,
  hfsMapId: GOOGLE_MAPS_MAP_ID,
};

export const appInfo = {
  useLogging: USE_LOGGING,
  webVersion: HFS_WEB_VERSION,
  appEnv: APP_ENV,
  appScheme: APP_SCHEME,
  appName: APP_NAME,
};

// candidates to move to remote-config
export const appConfig = {
  assetsBatchSize: ASSETS_BATCH_SIZE,
  wsHeartbeatIntervalSeconds: WS_HEARTBEAT_INTERVAL_SECONDS,
};

export const authConfig = {
  oidcUrl: OIDC_URL,
  oidcClientId: OIDC_CLIENT_ID,
  oidcRedirectUrl: OIDC_REDIRECT_URL,
  oidcLogoutRedirectUrl: OIDC_LOGOUT_REDIRECT_URL,
  iamClient: IAM_CLIENT,
  iamEndpoint: ENDPOINT_IAM,
  isimLoginUrl: ENDPOINT_ISIM_LOGIN,
  diamAccountPortalUrl: DIAM_ACCOUNT_PORTAL_URL,
  isimClientId: ISIM_LOGIN_CLIENT_ID,
};

export const firebaseConfig = {
  apiKey: FB_API_KEY,
  authDomain: FB_AUTH_DOMAIN,
  databaseURL: FB_DATABASE_URL,
  projectId: FB_PROJECT_ID,
  storageBucket: FB_STORAGE_BUCKET,
  messagingSenderId: FB_MESSAGING_SENDER_ID,
  appId: FB_APP_ID,
  measurementId: FB_MEASUREMENT_ID,
  appName: FB_APP_NAME,
  configFetchInterval: FB_CONFIG_FETCH_INTERVAL,
};

export const imageUploadConfig = {
  maxImageSizeMB: +MAX_IMAGE_UPLOAD_MB,
  maxImageSizeBytes: +MAX_IMAGE_UPLOAD_MB * 1024 * 1024,
  allowedImageTypes: ['image/jpeg', 'image/png'],
  mobileImageTypes: ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence'],
};

export const gktLayerConfig = {
  layerSettingsKey: 'gktLayerSettings',
  geojsonLayerSettingsKey: 'gktGeoJsonLayerSettings',
  activityLayerSettingsKey: 'gktActivityLayerSettings',
};
